import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { System } from '../core/models/dataContract.model';
import { ConfigService } from '../core/services/config.service';
import { catchError, tap } from 'rxjs/operators';
import { EMPTY, Subscription } from 'rxjs';
import { StartupService } from '../core/services/startup.service';
import { AuthService } from '../core/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  initialized = false;

  bgImage: string;
  bgFilterOpacity: number;

  systemSetting: any;
  systems: Array<System> = [];
  showSystems = true;
  loginMode = 'mix';

  constructor(
    private config: ConfigService,
    private router: Router,
    private startup: StartupService,
    public auth: AuthService
  ) { }

  ngOnInit() {
    this.subscription.add(
      this.startup.init().pipe(
        tap((result: boolean) => {
          this.initialized = true;
          if (result) {
            this.router.navigate(['/splash']);
          } else {
            this.bgImage = this.config.getConfigEx(
              'images:bgLogin',
              'assets/img/img-identity.jpg'
            );
            if (this.bgImage.indexOf('/') >= 0) {
              this.bgImage = `url(${this.bgImage})`;
            }

            this.bgFilterOpacity = this.config.getConfigEx(
              'images:bgLoginFilterOpacity',
              0.6
            );

            this.systemSetting = this.config.getConfig('systems', undefined);

            if (!this.systemSetting) {
              this.showSystems = false;
              this.loginMode = 'mix';
              this.systems = [];
            } else {
              this.showSystems = this.systemSetting.enabled ?? false;
              this.loginMode = this.systemSetting.loginMode;
              this.systems = this.systemSetting.items ?? [];
            }
          }
        }),
        catchError(() => {
          this.router.navigate(['/error']);
          return EMPTY;
        })
      ).subscribe()
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
